<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-card>
      <v-card-text class="pa-5">
        <v-row>
          <v-col>
            <h1>Редактирование ответа {{ lead.email }}</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <questions-answers-form
              :lead="lead"
              :errors="errors"
              @onSubmit="submit"
            ></questions-answers-form>
          </v-col>
        </v-row>
        <v-snackbar
          v-model="snackbarSuccess"
          :timeout="timeout"
          color="success"
        >
          Сохранено

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              @click="snackbarSuccess = false"
              color="red"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        <v-snackbar
          v-model="snackbarError"
          :timeout="timeout"
          color="error"
        >
          {{ this.errors }}

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              @click="snackbarError = false"
              color="red"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import {QuestionsAnswers} from "../../../models/answer";
import QuestionsAnswersForm from "../../../components/answers/QuestionsAnswersForm";

export default {
  name: 'Edit',
  components: {
    QuestionsAnswersForm,
  },
  data: () => ({
    lead: {},
    errors: {},
    snackbarSuccess: false,
    snackbarError: false,
    timeout: 2000,
    page: {
      title: "Редактирование ответа"
    },
    breadcrumbs: [
      {
        text: "Админ панель",
        disabled: false,
        to: '/'
      },
      {
        text: "Ответы на вопросы",
        disabled: true,
        to: '/answers'
      },
      {
        text: "Редактирование",
        disabled: true,
        to: '/answers/edit'
      },
    ],
  }),
  created() {
    this.find();
  },
  methods: {
    async submit({form}) {
      try {
        this.errors = {};

        await QuestionsAnswers.$query().update(form.id, form);
        this.snackbarSuccess = true;
        await this.$router.push({name: 'answers-index'});
      } catch (e) {
        this.snackbarError = true;
        if (e.response?.data) {
          this.errors = e.response.data.errors;
        }
        throw e;
      }
    },
    async find() {
      this.lead = (await QuestionsAnswers.$query().find(this.$route.params.id)).$attributes;
    },
  },
};
</script>
